export default function MapOverlays({ journey }) {
  const checkpointIndex = journey.checkpoints.findIndex(
    (checkpoint) => checkpoint.id === journey.currentCheckpoint?.id
  );
  const percent = Math.round(journey.progressRatio * 100);
  const remaining = Math.max(journey.totalDistance - journey.completedDistance, 0);

  return (
    <>
      <div className="map-status-pills">
        <span className="map-status-pill map-status-current">
          <i /> Đang tới {journey.currentCheckpoint?.name || journey.endLocation}
        </span>
        <span className="map-status-pill">
          📍 {Math.max(checkpointIndex + 1, 0)}/{journey.checkpoints.length} chặng
        </span>
      </div>

      <div className="map-compass" aria-hidden="true">
        <span>B</span>
        <span>Đ</span>
        <span>N</span>
        <span>T</span>
      </div>

      <button type="button" className="map-progress-card" aria-label="Xem thống kê hành trình">
        <span>
          {journey.completedDistance.toFixed(1)}/{journey.totalDistance} km
        </span>
        <strong>{percent}%</strong>
        <em>{remaining.toFixed(1)} km còn lại</em>
        <div className="map-progress-bar">
          <span style={{ width: `${percent}%` }} />
        </div>
      </button>
    </>
  );
}
